import { map, reduce, camelCase, upperFirst, kebabCase } from 'lodash'
import Vue from 'vue'

export const getErrors = function (validation) {
  const rules = {
    required: Vue.prototype.$t('validation.form.required', 'is required'),
    tel: Vue.prototype.$t('validation.form.phoneNumber', 'is not an valid phone number'),
    minLength: params => Vue.prototype.$t('validation.form.minLength', 'must have at least') + ` ${params.minLength.min} ` + Vue.prototype.$t('validation.form.length.letters', 'letters'),
    maxLength: params => Vue.prototype.$t('validation.form.maxLength', 'not more than') + ` ${params.maxLength.max} ` + Vue.prototype.$t('validation.form.length.letters', 'letters'),
    email: Vue.prototype.$t('validation.form.email', 'is not an valid email address'),
    sameAsEmail: Vue.prototype.$t('validation.form.confirmEmail', 'do not match'),
    password: Vue.prototype.$t('validation.form.password', 'must be 8-20 characters and must contain at least 2 of these 3 types of characters: letters (A-Z, a-z), digits (0-9), and symbols (_.@$)'),
    sameAsPassword: Vue.prototype.$t('validation.form.comfirmPassword', ':two passwords you entered are inconsistent'),
    zipCode: Vue.prototype.$t('validation.form.zipCode', 'is invalid'),
    houseNumber: Vue.prototype.$t('validation.form.houseNumber', 'is invalid'),
    name: Vue.prototype.$t('validation.form.name', 'is invalid'),
    includeNumber: Vue.prototype.$t('validation.form.includeNumber', 'must contain numbers'),
    address: Vue.prototype.$t('validation.form.address.notPOBoxOrFedEx', 'not allowed to be a pobox or fedex'),
    decimal: Vue.prototype.$t('validation.form.number', 'can only be a number'),
    dateFormat: Vue.prototype.$t('validation.form.date', {
      format: 'YYYY-MM-DD'
    }),
    Addressline1: Vue.prototype.$t('validation.form.address.line1', 'is invalid, rule: any number, letter, "-" and "/", 32 characters max'),
    Addressline2: Vue.prototype.$t('validation.form.address.line2', 'is invalid, rule: any number, letter, "-" and "/", 15 characters max'),
    town: Vue.prototype.$t('validation.form.address.town', 'is invalid, rule: Any letter and "-", 20 characters max;')
  }

  const errors = Object
    .keys(rules)
    .filter(key => validation[key] === false)
    .map(key => {
      if (typeof rules[key] === 'function') {
        return rules[key](validation.$params)
      }
      return rules[key]
    })
  return errors
}

export const mapValueProperties = (delegateTo, properties = [], _options = {}) => {
  const options = Object.assign({}, {
    eventName: delegateTo => `${kebabCase(delegateTo)}-change`,
    prefixed: false,
    emitAll: false,
    modifyOriginal: false
  }, _options)

  return properties.reduce((acc, prop) => {
    const propName = options.prefixed
      ? `${delegateTo}${upperFirst(camelCase(prop))}`
      : prop

    acc[propName] = {
      get () {
        return this[delegateTo][prop]
      },
      set (value) {
        const emitValue = options.emitAll
          ? {
            ...this[delegateTo],
            [prop]: value
          }
          : {
            key: prop,
            value
          }
        if (options.modifyOriginal) {
          this.$set(this[delegateTo], prop, value)
        }
        this.$emit(options.eventName(delegateTo), emitValue)
      }
    }
    return acc
  }, {})
}

export function extractErrorMessage (error) {
  let status = error.status || ''
  let errorMessages = error.data
  if (status && status === 401) {
    return Vue.prototype.$t('popuptips.loginExpired', 'Login expired, please login again')
  } else if (errorMessages) {
    if (Array.isArray(errorMessages)) {
      let errorArray = reduce(map(errorMessages, 'errorMessages'), (flattened, other) => {
        return flattened.concat(other)
      }, [])
      let errorMessageString = ''
      errorArray.forEach((item, index, array) => {
        const errorObj = { defaultValue: item.message, ...item, ...item.extraInfo }
        errorMessageString = errorMessageString +
          Vue.prototype.$t(`validation.${item.code}`, { ...errorObj }) + `${index === (array.length - 1) ? '' : '<br/>'}`
      })
      return errorMessageString
    } else {
      const errorObj = { defaultValue: errorMessages.message, ...errorMessages, ...errorMessages.extraInfo }
      return Vue.prototype.$t(`validation.${errorMessages.code}`, { ...errorObj })
    }
  } else {
    return Vue.prototype.$t('validation.error.message.unknowException', 'Internal Server Error') + `${status ? ` (${status})` : ''}`
  }
}
